import React from 'react'
import { Link } from 'react-router-dom'
import { RichText as PrismicRichText } from 'prismic-reactjs'
import { TwoColumnsSlice } from 'modules/prismic'
import { Wrapper } from './styled'

export const TwoColumns = ({ primary }: TwoColumnsSlice) => {
  const {
    image,
    button_label: buttonLabel,
    button_url: buttonUrl,
    content,
    content_alignment: textAlignment,
    align_image_right: alignImageRight,
    sub_heading: subHeading,
    heading,
    color_scheme: colorScheme
  } = primary

  return (
    <Wrapper alignImageRight={alignImageRight} textAlignment={textAlignment} colorScheme={colorScheme}>
      <div>
        {PrismicRichText.render(heading)}
        {PrismicRichText.render(subHeading)}
        {PrismicRichText.render(content)}
        {buttonLabel && buttonUrl && (
          <Link to={buttonUrl} className='btn'>
            {buttonLabel}
          </Link>
        )}
      </div>
      <img src={image.url} alt={image.alt ?? ''} width={image.dimensions?.width} height={image.dimensions?.height} />
    </Wrapper>
  )
}
